module.exports = __webpack_public_path__ + "static/item2_bg.cb211ffa.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/serviceProvider/item2_bg.png
// module id = 1048
// module chunks = 2